import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/message`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const fetchMessageTicketing = async (ticketingId, conversationId) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`ticketing/${ticketingId}/conversation/${conversationId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchTemplateMessageTicketing = async () => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl("reply-templates"), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const postMessageTicketing = async (ticketingId, { subject, body, to = [], pis = [], replyMessageId, isSolucion = false, files, type = "message" }) => {
  const auth = `Bearer ${getToken()}`;
  const formData = new FormData();
  formData.append("subject", subject);
  formData.append("body", body);
  formData.append("type", type);
  formData.append("isSolucion", isSolucion);
  for (let index = 0; index < to.length; index += 1) {
    formData.append("to[]", to[index]);
  }
  for (let index = 0; index < pis.length; index += 1) {
    formData.append("pis[]", pis[index]);
  }
  if (replyMessageId) {
    formData.append("replyMessageId", replyMessageId);
  }
  if (files) {
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });
  }
  let res = await fetch(readUrl(`ticketing/${ticketingId}/message`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
    },
    body: formData,
  });

  res = await parseJSON(res);

  return res.success;
};

export const postNoteTicketing = async (ticketingId, { subject, body, replyMessageId, visibility }) => {
  const auth = `Bearer ${getToken()}`;
  const formData = new FormData();
  formData.append("subject", subject);
  formData.append("body", body);
  formData.append("visibility", visibility);
  formData.append("replyMessageId", replyMessageId);
  let res = await fetch(readUrl(`ticketing/${ticketingId}/note`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
    },
    body: formData,
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchMessageNewSolucion = async (ticketingId, conversationId, messageId, isSolucion) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`ticketing/${ticketingId}/conversation/${conversationId}/message/${messageId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ isSolucion }),
  });

  res = await parseJSON(res);

  return res.success;
};
